import { IHours } from 'src/app/services/location.service';

export enum DateDays {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
    Sunday = 0
}

export enum DaysBit {
    None = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 4,
    Thursday = 8,
    Friday = 16,
    Saturday = 32,
    Sunday = 64
}

export class DateHelpers {
    public static convertDayToBit(day: DateDays) : DaysBit {
        if (day == DateDays.Monday) 
            return DaysBit.Monday;
        else if (day == DateDays.Tuesday)
            return DaysBit.Tuesday;
        else if (day == DateDays.Wednesday)
            return DaysBit.Wednesday;
        else if (day == DateDays.Thursday)
            return DaysBit.Thursday;
        else if (day == DateDays.Friday)
            return DaysBit.Friday;
        else if (day == DateDays.Saturday)
            return DaysBit.Saturday;
        else if (day == DateDays.Sunday)
            return DaysBit.Sunday;
        return DaysBit.None;
    }

    public static geCurrentDayName(day: DateDays) : string {
        if (day == DateDays.Monday) 
            return 'Monday';
        else if (day == DateDays.Tuesday)
            return 'Tuesday';
        else if (day == DateDays.Wednesday)
            return 'Wednesday';
        else if (day == DateDays.Thursday)
            return 'Thursday';
        else if (day == DateDays.Friday)
            return 'Friday';
        else if (day == DateDays.Saturday)
            return 'Saturday';
        else if (day == DateDays.Sunday)
            return 'Sunday';
        return '';
    }

    public static getCurrentDayOpenHours(hours: IHours[]) : IHours {
        let date = new Date();
        let dayBit: DaysBit = DateHelpers.convertDayToBit(date.getDay());

        let locationHour: IHours;

        hours.forEach(t => {
            if (t.Days & dayBit) {
                locationHour = t;
                return false;
            }
        });
        
        return locationHour;
    }
}